import { createSelector } from "reselect";
import { isDefined } from "@grandvisionhq/utils";
import { getStepsList, getCurrentStepIndex, stepsMapProp } from "../../../../state/state/selectors.internal.js";
const getSubSteps = createSelector(
  getStepsList,
  (steps) => steps.reduce((acc, step, i) => step.isSubStep ? [...acc, i] : acc, [])
);
const getSubStepsSubtractor = createSelector(
  getSubSteps,
  (subSteps) => (stepIndex) => stepIndex - subSteps.filter((sub) => sub < stepIndex).length
);
const getActiveStepIndex = createSelector(
  getCurrentStepIndex,
  getSubSteps,
  getSubStepsSubtractor,
  (currentStepIndex, subSteps, subStepSubtractor) => {
    if (!isDefined(currentStepIndex)) {
      return currentStepIndex;
    }
    if (subSteps.includes(currentStepIndex)) {
      let parentIndex = currentStepIndex - 1;
      while (subSteps.includes(parentIndex) && parentIndex >= 0) {
        parentIndex -= 1;
      }
      return subStepSubtractor(parentIndex);
    }
    return subStepSubtractor(currentStepIndex);
  }
);
const getStepLabels = createSelector(
  stepsMapProp,
  getStepsList,
  getSubSteps,
  (stepsMap, steps, subSteps) => steps.filter((_, index) => !subSteps.includes(index)).reduce((m, { name }) => {
    const stepData = stepsMap[name];
    return stepData?.labelKeys.stepIndicatorTitle ? [...m, stepData.labelKeys.stepIndicatorTitle] : m;
  }, [])
);
const getCurrentSubStepIndex = createSelector(
  getCurrentStepIndex,
  getSubSteps,
  (currentStepIndex, subSteps) => {
    if (!isDefined(currentStepIndex)) {
      return void 0;
    }
    if (subSteps.includes(currentStepIndex)) {
      let parentIndex = currentStepIndex - 1;
      while (subSteps.includes(parentIndex) && parentIndex >= 0) {
        parentIndex -= 1;
      }
      let subStepCount = 0;
      for (let i = parentIndex + 1; i <= currentStepIndex; i++) {
        if (subSteps.includes(i)) {
          subStepCount++;
        }
      }
      return subStepCount - 1;
    }
    return void 0;
  }
);
const getSubStepsPerStep = createSelector(getStepsList, getSubSteps, (steps, subStepIndices) => {
  const result = [];
  for (let i = 0; i < steps.length; i++) {
    if (subStepIndices.includes(i)) {
      continue;
    }
    let subStepCount = 0;
    let nextIndex = i + 1;
    while (nextIndex < steps.length && subStepIndices.includes(nextIndex)) {
      subStepCount++;
      nextIndex++;
    }
    result.push(subStepCount);
  }
  return result;
});
const getStepWizardData = createSelector(
  getActiveStepIndex,
  getStepLabels,
  getSubStepsPerStep,
  getStepsList,
  getCurrentSubStepIndex,
  (currentStepIndex, stepLabels, subStepsPerStep, stepsList, currentSubStepIndex) => ({
    currentStepIndex,
    stepLabels,
    subStepsPerStep,
    stepsList,
    currentSubStepIndex
  })
);
export {
  getStepWizardData
};
//# sourceMappingURL=selectors.internal.js.map
